<template>
  <div v-if="!isInternationalMode">
    <h3 class="small-margin-bottom-s large-margin-bottom-m">
      Ratings & Reviews
    </h3>

    <span
      class="no-reviews-text"
    >{{ noReviewsText }}</span>

    <div class="margin-top-s">
      <Reviewlet
        :interactive="true"
        size="large"
        @onchange="redirectToWriteReview"
      />
    </div>
  </div>
</template>

<script setup>
import Reviewlet from '@atomic-ui/reviewlet';
import { useBrand } from '@composables/useBrand';
import { useReviewsRedirect } from '@composables/reviews/useReviewsRedirect';
import { useFeatureEligibility } from '@modules/featureControl';

const { isMcom } = useBrand();

const { redirectToWriteReview } = useReviewsRedirect();

const { isInternationalMode } = useFeatureEligibility();

const noReviewsText = isMcom
  ? 'No reviews yet. Tell us what you think!'
  : 'Hey trailblazer! Be the first to write a review.';
</script>

<style lang="scss" scoped>
.no-reviews-text {
  font-weight: 500;
}
</style>
